import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { PATH } from '../../../assets/constants';
import { AuthenticationService } from '../services/authentication.service';

@Injectable( {
  providedIn: 'root',
} )
export class AuthGuard  {
  private authService = inject(AuthenticationService);
  private router = inject(Router);

  constructor() {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const queryToken = route.queryParamMap.get('token');
    if (queryToken && this.authService.isGoogleTokenValid(queryToken)) {
      this.authService.setAccessToken(queryToken);
      return true;
    }

    if ( this.authService.isTokenValid() ) {
      return true;
    } else {
      this.router.navigate( [ PATH.LOGIN ] );
      return false;
    }
  }
}
